module.exports = __webpack_public_path__ + "img/logo_tikkl.17259955.svg";